import { ActionTypes } from "../constants/action-types";

const initialState = {
    nbHitsCount:1
  };


export const nbHitsCountReducer = (state = initialState, { type, payload }) => {
    switch (type) {
      case ActionTypes.NB_HITS_COUNT_DATA:
        return {
          ...state,
          nbHitsCount: payload,
        };
      default:
        return state;
    }
  };